<div class="mainDiv">
    <div class="newOrder">
        <div style="width: 90%;text-align: center;">
            <h3>New Delivery!</h3>
        </div>

        <div *ngIf="showCloseIcon" style="width: 10%;">
            <mat-icon (click)="hide()" class="address_span"
                style="font-size: 22px !important;overflow: inherit;background: none;width: 100%;">highlight_off
            </mat-icon>
        </div>
    </div>

    <div>
        <div style="background: white; overflow: auto;">
            <div class="container" style="padding: 10px !important;">
                <agm-map [latitude]="latitude" [longitude]="longitude" [zoom]="zoom">
                    <agm-direction [origin]="origin" [destination]="destination" [waypoints]="waypoints"
                        [renderOptions]="renderOptions" [markerOptions]="markerOptions">
                    </agm-direction>

                </agm-map>
                <!-- <google-map height="320px" width="100%" [center]="center" [zoom]="zoomMap" [options]="mapOptions">
                    <map-marker *ngIf="origin" [position]="origin" [options]="originMarkerOptions">
                    </map-marker>

                    <map-marker *ngIf="destination" [position]="destination" [options]="destinationMarkerOptions">
                    </map-marker>

                    <map-directions-renderer *ngIf="directionsResults" [directions]="directionsResults">
                    </map-directions-renderer>
                </google-map> -->
            </div>
        </div>
    </div>

    <div style="padding: 5px;">
        <div class="earningSection"><span>Expected Earning : </span><span>₹{{price}}</span></div>
        <div class="flex_width"><span style="width: 30%;" class="width_20">Distance : </span><span
                style="width: 26%; font-weight: 500;" class="width_80">{{distance}}KM</span></div>
        <div class="flex_width"><span class="width_20">Drop : </span><span class="width_80">{{toAddress}}.</span></div>
        <div class="flex_width"><span class="width_20">Pickup : </span><span class="width_80">{{fromAddress}}.</span>
        </div>
    </div>

    <div class="all_btn">
        <button class="denyBtn" (click)="onAcceptOrDeclineClick('Rider Declined')">
            <div style="padding-top: 0px; padding-right: 5px;">
                <mat-icon>close</mat-icon>
            </div>
            Deny
        </button>

        <button class="acceptBtn" (click)="onAcceptOrDeclineClick('Rider Accepted')">
            <div style="padding-top: 0px; padding-right: 5px;">
                <mat-icon>check</mat-icon>
            </div>
            Accept
        </button>
    </div>

</div>